/**
 * Removes legacy query credentials immediately, but retains fragment access
 * until the server has successfully exchanged it for an HttpOnly cookie.
 */
export function cleanOrderAccessLocation(
  href: string,
  orderId: string,
  fragmentExchanged: boolean,
): string {
  const url = new URL(href);
  url.searchParams.delete("token");
  if (orderId) url.searchParams.set("id", orderId);
  if (fragmentExchanged) {
    const fragment = new URLSearchParams(url.hash.replace(/^#/, ""));
    fragment.delete("token");
    fragment.delete("id");
    url.hash = fragment.toString();
  }
  return url.pathname + url.search + url.hash;
}
